import Request from "../lib/request";
import {SEND_REFERENCE_LINK_API} from "../constants/api";

const baseUrl = process.env.REACT_APP_API_URL;

export const reject = (id) => {
  return Request({
    method: "get",
    url: `${baseUrl}/rejectInvitation/${id}`,
    needToken: true
  });
};

export const accept = (id) => {
  return Request({
    method: "get",
    url: `${baseUrl}/acceptInvitation/${id}`,
    needToken: true
  });
};

export const checkPhoneNumber = (data) => {
  return Request({
    method: "get",
    url: `${baseUrl}/checkPhoneNumber/${data.phone_number}`,
    needToken: true,
  });
};

export const sendSms = (token) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "get",
    url: `${baseUrl}/projects/${projectId}/sendSms/${token}`,
    needToken: true
  });
};

export const invite = (data) => {
  const projectId = localStorage.getItem("project_id");
  return Request({
    method: "post",
    url: `${baseUrl}/projects/${projectId}/invite`,
    needToken: true,
    data
  });
};

export const inviteToApp = (data) => {
  return Request({
    method: "post",
    url: `${baseUrl}/${SEND_REFERENCE_LINK_API}`,
    needToken: true,
    data
  });
};